import myaxiosUpload from './axiosUpload.service'
import env from '@/../.env'

function convertObjToFormData(obj)
{
    var formData = new FormData();

    for (var key in obj) {
        formData.append(key, obj[key]);
    }

    formData.append('id', env.API_FILE_ID)
    formData.append('token', env.API_FILE_TOKEN)

    return formData
}

const ApiUploadService = {
    post: async function (obj) {
        return await myaxiosUpload.post('', convertObjToFormData(obj))
    }
}
export default ApiUploadService



// WEBPACK FOOTER //
// ./src/services/apiUpload.service.js